module.exports = __webpack_public_path__ + "img/govpage_main.f404995b.png";